import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/libs/components/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationEvents"] */ "/app/src/libs/utils/helpers/navigation.ts");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
